import { matchPath } from 'react-router';

import { TenantNavigationItems } from '../../../../../../config';
import { NavItem } from '../../../types/NavItem';

export const configToNavItem = (
  item: TenantNavigationItems,
  pathname?: string,
): NavItem => ({
  label: item.text,
  href: item.href,
  key: item.href,
  selected: pathname
    ? !!matchPath({ path: item.href, end: false }, pathname)
    : false,
});
